const initialState = {
  name: false,
  data: [],
};

const imrReducer = (state = initialState, action) => {
  let reset = [];
  switch (action.type) {
    case 'VALUE-IMR':
      return {
        ...state,
        name: !state.name,
      };
    case 'ADD_OBJECT':
      return {
        ...state,
        name: true,
        data: [...state.data, action.payload],
      };
    case 'RESET':
      return {
        ...state,
        name: false,
        data: reset,
      };

    default:
      return state;
  }
};

export default imrReducer;
